<!--<app-scroll-top></app-scroll-top>-->
<div class="agence-bytdm">
  <div class="slider-bg-img gradient01 ">
    <div class="container">
      <nav class="py-4">
        <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
            <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Agence byTDM</span></li>
        </ol>
      </nav>
      <div class="row row-cols-md-2 row-cols-sm-1 ">
        <div class="slider-txt py-md-5 py-sm-2">
          <div class="h-100">
            <div class="slider-img">
              <img [src]="infoAgence?.urlLogo" alt="{{infoAgence?.nom}}">
            </div>
            <br/>
            <h1 class="heading" *ngIf="article?.texte">NOTRE <span style="color : #BADFFF"> HISTOIRE</span></h1>
            <ng-container *ngIf="article?.texte?.length > limiteTexte">
              <h6 class="description nl2br">
                {{article.texte| slice:0:limiteTexte}}<span id="collapseTexteHistoireAgence" #collapse="ngbCollapse" [ngbCollapse]="!isTexteCollapsed" (ngbCollapseChange)="isTexteCollapsed = $event"
                                                            [horizontal]="true">{{article.texte| slice:limiteTexte:article.texte.length}}</span>
              </h6>
              <div>
                <button type="button" class="btn btn-outlined" (click)="isTexteCollapsed = ! isTexteCollapsed"
                        [attr.aria-expanded]="isTexteCollapsed" aria-controls="collapseTexteHistoireAgence">
                  {{(!isTexteCollapsed) ? 'Lire la suite' : 'Masquer la suite'}}
                </button>
              </div>
            </ng-container>
            <ng-container *ngIf="article?.texte?.length <= limiteTexte">
              <h6 class="description nl2br">{{article?.texte}}</h6>
            </ng-container>
          </div>
          <div>
          </div>
        </div>
        <div class="slider-img" *ngIf="article?.urlimage">
          <img style="border-radius: 50% 50% 0% 0%;" [src]="article?.urlimage" alt="Interieur cosi">
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="dataAgence?.biens?.length > 0" class="py-5 text-center container" id="ancre-mes-bien">
    <h2 class="text-uppercase text-black mb-4">LES <span class="text-bleu-tdm">biens</span></h2>
    <div class="grid-biens text-black">
      <div class="grid-biens-child" *ngFor="let bien of biensPaginated">
        <app-card-bien (saveOrUpdate)="doRefreshList($event)" [bien]="bien" (bienClicked)="onBienClicked(bien)"></app-card-bien>
      </div>
    </div>
    <div class="my-4 text-black pagination-ami-bien">
      <app-pagination [current]="current" [total]="total" (goTo)="onGoTo($event)" (next)="onNext($event)" (previous)="onPrevious($event)"></app-pagination>
    </div>
  </div>
</div>
